export default __webpack_public_path__ + "static/media/joke-sphere.vert.9813c239.glsl";